import { render } from "./AudioLibraryEditModal.vue?vue&type=template&id=af5be284&scoped=true"
import script from "./AudioLibraryEditModal.vue?vue&type=script&lang=js"
export * from "./AudioLibraryEditModal.vue?vue&type=script&lang=js"

import "./AudioLibraryEditModal.vue?vue&type=style&index=0&id=af5be284&scoped=true&lang=less"
import "./AudioLibraryEditModal.vue?vue&type=style&index=1&id=af5be284&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5be284"]])

export default __exports__